import {Icon as PepsicoDsIcon} from '@pepsico-ds/ui'
import PropTypes from 'prop-types'

/**
 * Icon component that renders a PepsicoDsIcon with various props.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.alt - The alt text for the icon.
 * @param {boolean} [props.disabled=false] - Whether the icon is disabled.
 * @param {boolean} [props.isDark=false] - Whether the icon is in dark mode.
 * @param {('small'|'medium')} [props.size='medium'] - The size of the icon.
 * @param {string} [props.className] - Additional class names for the icon.
 * @param {string} props.icon - The name of the icon to be displayed.
 * @param {Object} [props.rest] - Additional properties to be passed to the PepsicoDsIcon component.
 * @param {string} [props.id=''] - Optional additional id to apply to the icon.
 * @returns {JSX.Element} The rendered PepsicoDsIcon component.
 */
export default function Icon({alt = '', disabled = false, isDark: _isDark, size = 'medium', className, icon, id, ...props}) {
  void _isDark

  return (
    <PepsicoDsIcon
      data-testid={`icon` + (id ? `_${id}` : '')}
      id={`icon` + (id ? `_${id}` : '')}
      alt={alt}
      disabled={disabled}
      size={size}
      className={className}
      icon={icon}
      {...props}
    />
  )
}

Icon.propTypes = {
  alt: PropTypes.string,
  disabled: PropTypes.bool,
  isDark: PropTypes.bool,
  size: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  id: PropTypes.string,
}
